import React, { Profiler } from 'react';

const MAX_EVENTS = 500;

export function recordProfilerCommit(id, phase, actualDuration, baseDuration, startTime, commitTime) {
  if (typeof window === 'undefined') return;
  const events = Array.isArray(window.__mitusReactProfilerEvents)
    ? window.__mitusReactProfilerEvents
    : [];
  window.__mitusReactProfilerEvents = [
    ...events.slice(-(MAX_EVENTS - 1)),
    { id, phase, actualDuration, baseDuration, startTime, commitTime },
  ];
}

export default function ReactProfilerBoundary({ id = 'mitus-application', children }) {
  return (
    <Profiler id={id} onRender={recordProfilerCommit}>
      {children}
    </Profiler>
  );
}
